import styled from 'styled-components';

export const TopSummaryLineWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 767px) {
    justify-content: flex-start;
  }
`;

export const SummaryDataContainer = styled.div`
  display: flex;
`;

export const TopSummaryLineContent = styled.div<{
  direction: 'ltr' | 'rtl';
}>`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: flex-start;
  @media (max-width: 767px) {
    margin-bottom: 12px;
  }
  
  [class*='SaveArticleIconstyles__SaveTextWrapper'] {
    ${props => props.direction === 'ltr' ? 'margin-inline-end: 32px;'
    : 'margin-inline-start: 32px;'}
  }
`;

export const DateIconWrapper = styled.div`
  display: flex;
  align-items: center;

  > span {
    margin-inline-end: 4px;
  }
`;

export const DateTextWrapper = styled.div`
  font-size: 18px;
  line-height: 26px;
  text-wrap: nowrap;

  @media only screen and (max-width: 370px) {
    font-size: 16px;
  }
`;

export const ReadingTimeTooltipWrapper = styled.div`
  #reading-time-tooltip {
    opacity: 1;
    max-width: 278px;
    background-color: #fff;
    color: #000;
    border-radius: 6px;
    box-shadow: -10px 0px 10px rgba(0, 0, 0, 0.16);

    > div {
      margin: 0;

      > p {
        margin: 0 !important;
      }
    }
  }
`;

export const ReadingTimeContainer = styled.div`
  display: flex;
  font-size: 18px;
  line-height: 26px;
  text-wrap: nowrap;
  align-items: center;

  @media only screen and (max-width: 370px) {
    font-size: 16px;
  }

  margin: 0 30px;

  @media only screen and (max-width: 450px) {
    margin: 0 10px;
  }

  @media only screen and (max-width: 370px) {
    margin: 0 5px;
  }
`;

export const ReadingTimeTextWrapper = styled.div`
  margin-inline-start: 4px;

  @media (max-width: 638px) {
    margin-inline: 4px 0;
  }
`;

export const PillContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 46px;

  @media (max-width: 767px) {
      margin-bottom: 15px;
    }
`

export const PillWrapper = styled.div`
  font-weight: 700;
  margin-inline-end: 32px;

  @media (max-width: 638px) {
    margin-inline-end: 10px;
    margin-top: 10px;
  }

  [class*='Pillstyle__Pill-sc'] {
    height: 26px;
    display: block;
    padding: 4px 16px;
  }
`;

export const ContentLevelWrapper = styled.div`
  text-decoration: underline;
  text-underline-offset: 6px;
  text-decoration-color: ${props => props.theme.color.secondary5.default};
  font-size: 14px;
  text-wrap: nowrap;

  @media (max-width: 767px) {
      margin-top: 3px;
    }
`;

export const DesktopButtonContainer = styled.div`
  @media (max-width: 767px) {
      display: none;
    }
`;

export const MobileButtonContainer = styled.div`
  margin-bottom: 10px;
  @media (min-width: 768px) {
      display: none;
    }
`;

export const SummaryCardWrapper = styled.div`
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 6px;
  padding: 20px 40px;

  @media (max-width: 638px) {
    padding: 20px 14px 8px 14px;
  }
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 14px;

  > h2:first-child {
    margin-top: 0;
    font-size: 24px;
    line-height: 44px;
    font-weight: 700 !important;

    @media (max-width: 638px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

export const SummaryContentWrapper = styled.div`
  @media (max-width: 638px) {
    margin-inline-start: 4px;
  }
`;

export const SummaryItemContainer = styled.div`
  display: flex;
  cursor: pointer;
  margin: 4px 0;
  align-items: baseline;
`;

export const SummaryItemIconWrapper = styled.div`
  margin-inline-end: 14px;

  svg {
    width: 29px;
    height: 29px;

    path {
      fill: #e60000;
    }

    @media (max-width: 638px) {
      width: 21px;
      height: 21px;
    }
  }
`;

export const SummaryItemTextWrapper = styled.div`
  font-size: 20px;
  line-height: 32px;

  @media (max-width: 638px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const SummarySpacer = styled.div`
  margin: 0 15px;

  @media only screen and (max-width: 450px) {
    margin: 0 10px;
  }

  @media only screen and (max-width: 370px) {
    margin: 0 5px;
  }
`;